import { render, staticRenderFns } from "./index.vue?vue&type=template&id=971875d8&scoped=true&"
var script = {}
import style0 from "./documentation-matrix.scss?vue&type=style&index=0&id=971875d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971875d8",
  null
  
)

export default component.exports